<template>
  <div class="container">
    <el-carousel class="banner"
      trigger="click"
      height="468px">
      <el-carousel-item v-for="item in 3"
        :key="item">
        <img :src="require(`../../assets/image/brand-banner${item}.png`)"
          alt="">
      </el-carousel-item>
    </el-carousel>
    <div class="des">澳覓有一支成熟的品牌創意團隊，團隊負責人有著多年的著名4A廣告公司經驗。團隊能為客戶提供品牌升級與創意營銷服務，包括但不僅限於品牌環境調研、明確品牌定位、品牌設計、品牌推廣策略等全方位的服務，以協助企業或商家打造熱點營銷事件，提升品牌的市場影響力，實現更多營收。</div>
    <div class="update">
      <div class="title">
        <p class="sub">BRANDING UPGRATING</p>
        <p class="head">品牌升級</p>
      </div>
      <div class="list">
        <img v-for="item in 4"
          :src="require(`../../assets/image/brand${item}.png`)"
          alt=""
          :key="item">
      </div>
      <div class="content">澳門有松山，松山有松鼠。澳覓此次品牌體驗設計將代表澳門特色的“松鼠”形象進行創作升級。立起來的耳朵寓意聽取用戶想法，更友好地為用戶創造美好生活；形象外輪廓寓意不設限，讓每個人用心感受生活；品牌色澳覓紅寓意澳覓熱情洋溢的服務態度。澳覓品牌精選真正有價值的內容與產品，並將其推薦給關聯用戶的體驗形式，使澳覓APP形成更具差異化的品牌體驗和品牌識別。全新的品牌標識與slogan結合能夠體現澳覓小松鼠明快隨和的形象，品牌色澳覓紅，以及能夠延續品牌風格的專用字體，圖形標識等品牌核心元素，形成了一套完整的能夠在線上線下多個用戶體驗觸點中高度統一的視覺風格。</div>
    </div>
    <div class="activity">
      <div class="title">
        <p class="sub">BRANDING ACTIVITIES</p>
        <p class="head">品牌活動</p>
      </div>
      <div class="item">
        <div class="left">
          <p class="name">「澳覓·甜蜜新風尚」大型主題活動</p>
          <p class="section">澳覓與南光集團旗下年度盛事「澳門遊艇展」在漁人碼頭聯合推出的一次全新的生活方式美食體驗市集。</p>
          <p class="section">在澳門首次以甜品為主題，集合全澳24家優質甜品美食商戶，享受快閃網紅打卡新體驗。</p>
          <p class="section-s">· 活動3天人流量突破100,000人次；</p>
          <p class="section-s">· 「澳覓APP」、「澳門遊艇展」、「參展商戶」、「工銀澳門」四方品牌在活動前後得到有效曝光；</p>
        </div>
        <div class="right">
          <video src="../../assets/image/video1.mp4"
            poster="../../assets/image/video1-bg.png"
            controls></video>
          <p>「澳覓·甜蜜新風尚」宣傳視頻</p>
        </div>
      </div>
      <div class="item">
        <div class="left left-reverse">
          <p class="name">hush! x 本地文創徵集</p>
          <p class="section">入選為2019澳門文化局HUSH!黑沙沙灘音樂節 <br>
          6位官方文創合作夥伴之一</p>
          <p class="section">入選產品</p>
          <p class="section-s">充電寶、紙巾、貼紙、帆布袋、 Choker 頸鏈、耳環、發亮夜光頭飾</p>
        </div>
        <div class="right right-reverse">
          <video src="../../assets/image/你.ogg"
            poster="../../assets/image/video2-bg.png"
            controls></video>
          <p>「澳覓·甜蜜新風尚」宣傳視頻</p>
        </div>
      </div>
      <div class="item">
        <div class="left">
          <p class="name">「2019澳覓限定新春禮盒」</p>
          <p class="section">澳覓春節主題文創產品 + 澳門本地味道</p>
          <p class="section-s">限量發售的禮盒</p>
        </div>
        <div class="right">
          <img src="../../assets/image/video3.png"
            alt="">
          <p>澳覓 x 龍昌行海味禮盒</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Carousel, CarouselItem } from "element-ui"

export default {
  components: {
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  }
}
</script>
<style lang="scss" scoped>
.container {
  width: 1200px;
  margin: 125px auto 0;
  .banner {
    width: 100%;
    height: 468px;
  }
  .des {
    position: relative;
    width: 775px;
    font-size: 19px;
    line-height: 1.8;
    padding: 55px 70px;
    font-weight: 500;
    margin: -110px auto 0;
    text-align: left;
    background-color: #fff;
    z-index: 9;
  }
  .update {
    .title {
      text-align: center;
      .sub {
        font-size: 14px;
        color: #ff3159;
      }
      .head {
        font-size: 30px;
        font-weight: bold;
      }
    }
    .list {
      width: 1075px;
      margin: 35px auto 0;
      display: flex;
      justify-content: space-between;
    }
    .content {
      width: 945px;
      font-size: 17px;
      line-height: 1.8;
      font-weight: 500;
      margin: 30px auto 0;
      text-align: left;
    }
  }
  .activity {
    margin-top: 58px;
    .title {
      text-align: center;
      .sub {
        font-size: 14px;
        color: #ff3159;
      }
      .head {
        font-size: 30px;
        font-weight: bold;
      }
    }
    .item {
      position: relative;
      width: 1137px;
      height: 345px;
      background-color: #f0eff4;
      margin-top: 63px;
      .left {
        width: 450px;
        margin-left: 123px;
        padding-top: 63px;
        text-align: left;
        .name {
          font-size: 22px;
          font-weight: 500;
          padding-bottom: 25px;
        }
        .section {
          font-weight: 500;
          font-size: 17px;
          line-height: 1.8;
          padding-bottom: 10px;
        }
        .section-s {
          font-size: 15px;
        }
      }
      .right {
        position: absolute;
        right: 25px;
        top: -25px;
        width: 501px;
        height: 345px;
        video,
        img {
          display: block;
          width: 100%;
          height: 280px;
          outline: none;
        }
        p {
          line-height: 65px;
          font-size: 15px;
          color: #fff;
          padding-left: 30px;
          background-color: #15161e;
          text-align: left;
        }
      }
      .left-reverse {
        margin-left: 580px;
        .name {
          text-align: right;
        }
        .section {
          text-align: right;
        }
        .section-s {
          text-align: right;
        }
      }
      .right-reverse {
        left: 25px;
      }
    }
  }

  /deep/ .el-carousel__indicators--horizontal {
    bottom: 110px;
  }
}
</style>